import React, { useEffect, useState } from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend } from 'recharts';
import axios from 'axios';
import {getDatabaseStatsGridData} from "../../WorkDashboard/WorkDashboardStats/WorkDashboardStatsClient";
import {getContractStatusPie} from "../../Contract/ContractClient";
import {getOwedGeneratedM4mktPie} from "../../ContractDataPoint/ContractDataPointClient";

// const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];
const COLORS = [
    '#1E90FF', // rgb(30,144,255)
    '#45B1E8', // rgb(69,177,232)
    '#87CEFA', // rgb(135,206,250)
    '#89CFF0', // rgb(137,207,240)
    '#ADD8E6', // rgb(173,216,230)
    '#87CEEB', // rgb(135,206,235)
    '#E7FEFF', // rgb(231,254,255)
    '#F4F0EC', // rgb(244,240,236)
    '#FAFAFA'  // rgb(250,250,250)
];

const OwedM4mktPieChart = () => {
    const [statusPieData, setStatusPieData] = useState([]);


    const fetchOwedM4mktPie = () =>
        getOwedGeneratedM4mktPie()


            .then(data => {
                const formattedData = data.map(item => ({
                    name: item.breakField,
                    // value: parseInt(item.count, 10),
                    value: item.countField
                }));
                console.log("status pie chart data", formattedData);
                setStatusPieData(formattedData);
            })
            .catch(error => {
                console.error('Error fetching data', error);
            });
    useEffect(() => {
        fetchOwedM4mktPie();
    }, []);
    //
    // useEffect(() => {
    //     const fetchData = async () => {
    //         try {
    //             const response = await axios.get('/api/status-query');
    //             const formattedData = response.data.map(item => ({
    //                 name: item.status,
    //                 value: parseInt(item.count, 10),
    //             }));
    //             setData(formattedData);
    //         } catch (error) {
    //             console.error('Error fetching data', error);
    //         }
    //     };
    //     fetchData();
    // }, []);

    return (
        <div>
            <PieChart width={400} height={400}>
                <defs>
                    {COLORS.map((color, index) => (
                        <linearGradient id={`color${index}`} key={index} x1="0" y1="0" x2="1" y2="1">
                            <stop offset="0%" stopColor={color} stopOpacity={0.7}/>
                            <stop offset="100%" stopColor={color} stopOpacity={1}/>
                        </linearGradient>
                    ))}
                </defs>
                <Pie
                    data={statusPieData}
                    cx="50%"
                    cy="50%"
                    // cx={200}
                    // cy={200}
                    outerRadius={150}
                    fill="#8884d8"
                    dataKey="value"
                    label={"Contract Status"}
                >
                    {statusPieData.map((entry, index) => (
                        // <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]}/>
                        // <Cell key={`cell-${index}`} fill={`url(#color${index})`} />
                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                    ))}
                </Pie>
                <Tooltip/>
                <Legend>Contract Status</Legend>
            </PieChart>
        </div>
    );
};

export default OwedM4mktPieChart;
